import { Viewport } from 'pixi-viewport';
import RectifiedImage from './RectifiedImage';
import ImageCrops from './ImageCrops';
import bus, { EVENTS } from './bus';
import componentBus, { EVENTS as componentBusEvents } from '../components/componentBus';

export default class SkuValidationScene extends PIXI.Application {
  constructor(options, scene) {
    super({
      ...options,
      autoResize: true,
      transparent: true
    });

    this.scene = scene;

    componentBus.$on(componentBusEvents.ADD_TO_POOL, this.handleAddToPool);
  }

  handleAddToPool = () => {
    const [rectifiedImage, imageCropsWrapper] = this.viewport.children;

    const { projection_sprite } = rectifiedImage;
    const selectedCrop = imageCropsWrapper.children.find(item => item.is_selected);

    if (selectedCrop) {
      const tempContainer = new PIXI.Container();

      tempContainer.addChild(projection_sprite);

      const tmpRenderTexture = this.renderer.generateTexture(tempContainer, PIXI.SCALE_MODES.LINEAR, 1, selectedCrop.getLocalBounds());

      const encodedImage = this
        .renderer
        .extract
        .base64(tmpRenderTexture, 'image/jpeg');

      componentBus.$emit(componentBusEvents.POST_SKU_CANDIDATE, { encodedImage });

      rectifiedImage.addChild(projection_sprite);
      tempContainer.destroy();
    }
  }

  removeCustomEvents() {
    componentBus.$off(componentBusEvents.ADD_TO_POOL, this.handleAddToPool);
  }

  async setupMaterials() {
    try {
      this.addViewport();
      await this.addRectifiedImage();

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  addViewport() {
    this.viewport = new Viewport({
      screenWidth: this.screen.width,
      screenHeight: this.screen.height,
      stopPropagation: true,
      passiveWheel: false,
      noOnContextMenu: true,
      divWheel: this.renderer.view,
      interaction: new PIXI.InteractionManager(this.renderer)
    }).drag()
      .pinch()
      .wheel();

    bus.viewport = this.viewport;
    this.listenEvents();

    this.stage.addChild(this.viewport);
  }

  async addRectifiedImage() {
    const { url, camera_view } = this.scene;
    const rectifiedImage = new RectifiedImage(url, camera_view);

    await rectifiedImage.rectify();

    this.viewport.addChild(rectifiedImage);

    this.moveCenter();
    this.addImageCrops();

    return Promise.resolve();
  }

  moveCenter() {
    if (this.stage) { // It can be already destroyed
      this.viewport
        .moveCenter(this.viewport.width / 2, this.viewport.height / 2)
        .fit(true, this.viewport.width, this.viewport.height);
    }
  }

  addImageCrops() {
    const imageCrops = new ImageCrops(this.scene.crops, this.viewport);
    this.viewport.addChild(imageCrops);
  }

  listenEvents = () => {
    this.viewport.on('zoomed-end', () => {
      bus.$emit(EVENTS.ZOOM_END);
    });
  }
}
